/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";

import { Observable } from 'rxjs';

import {BaseService} from "./base-service";
import {AuthenticationService} from "./authentication.service";
import {Router} from "@angular/router";
import {Group} from "../models/group";
import { RestService } from "./rest-service";
import { HttpClient } from "@angular/common/http";
import { Url_Base } from "app/rest-constants";

@Injectable()
export class UserGroupService extends BaseService {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService,
    private http: HttpClient
  ) {
    super(router, authenticationService);
  }

  private getUrl(): string {
    return `${Url_Base}/groups/users`;
  }

  getUserGroup(id: number): Promise<Group> {
	const rootUrl = this.getUrl() + "/" + `${id}`;
    return this.mRestService.get<Group>(rootUrl);
  }

  getAllUserGroups(): Promise<Group[]> {
    const url = this.getUrl();
    return this.mRestService.get<Group[]>(url);
  }

  search(prefix: string): Observable<Group[]> {
    const url = this.getUrl() + '/search/' + `${prefix}`;
    
    return this.http
        .get<Group[]>(url, this.mRestService.createBasicHttpOptions())
        .catch(error => this.handleError(error))
  }

  createUserGroup(group: Group): Promise<Group> {
    const url = this.getUrl();
    return this.mRestService.post<Group>(url, group);
  }

  updateUserGroup(group: Group): Promise<Group> {
    const url = this.getUrl();
    return this.mRestService.put<Group>(url, group);
  }

  deleteUserGroup(groupId: number): Promise<Group> {
    const url = `${this.getUrl()}/${groupId}`;
    return this.mRestService.delete<Group>(url);
  }

}
